export const TASK_FEEDBACK_OPTIONS = [
  "makkiepakkie",
  "lastig maar ok",
  "moeilijk, ik heb vragen",
];

export const TASK_FEEDBACK_LABEL_BY_VALUE = {
  makkiepakkie: "makkiepakkie 😀",
  "lastig maar ok": "lastig maar ok 😮‍💨",
  "moeilijk, ik heb vragen": "moeilijk, ik heb vragen 🤔",
};

export function getTaskFeedbackLabel(value) {
  return TASK_FEEDBACK_LABEL_BY_VALUE[value] || value;
}
